module.exports = __webpack_public_path__ + "static/media/total-info.13610c1b.png";